import { useState } from "react";
import PublicLayout from "@/components/layout/PublicLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import api from "@/lib/api";

export default function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [category, setCategory] = useState("algemeen");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const send = async () => {
    if (!name || !email || message.length < 5) return;
    setLoading(true);
    try {
      await api.post("/contact", { name, email, category, subject, message });
      toast.success("Bericht verstuurd. We reageren binnen 1 werkdag.");
      setName(""); setEmail(""); setSubject(""); setMessage("");
    } catch {
      toast.error("Versturen mislukt.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PublicLayout>
      <section className="oc-section">
        <div className="oc-container grid lg:grid-cols-5 gap-14">
          <div className="lg:col-span-2 space-y-7">
            <div>
              <span className="text-[13px] uppercase tracking-[0.1em] font-semibold text-oc-secondary">Contact</span>
              <h1 className="font-display font-bold text-[40px] sm:text-[52px] leading-tight tracking-tight text-oc-primary mt-3">
                Hulp nodig?
              </h1>
              <p className="mt-4 text-oc-textSecondary text-[17px] leading-relaxed">
                We reageren doorgaans binnen 1 werkdag. Voor facturatie- of GDPR-verzoeken: <a className="text-oc-secondary underline" href="mailto:info@offerteexpert.be">info@offerteexpert.be</a>.
              </p>
            </div>
            <div className="bg-oc-subtle border border-oc-border rounded-oc p-7 space-y-3 text-[15px]">
              <p className="font-display font-semibold text-oc-primary">Webtron BV</p>
              <p className="text-oc-textSecondary leading-relaxed">A. Rodenbachwijk 12<br/>9792 Waregem, België<br/>BTW BE0793944703</p>
              <p className="text-oc-textSecondary"><a className="text-oc-secondary underline" href="mailto:info@offerteexpert.be">info@offerteexpert.be</a></p>
            </div>
          </div>

          <div className="lg:col-span-3 bg-white border border-oc-border rounded-oc p-9 space-y-5">
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>Naam</Label>
                <Input data-testid="contact-name" value={name} onChange={(e) => setName(e.target.value)} className="h-12 rounded-oc-btn" />
              </div>
              <div className="space-y-2">
                <Label>E-mailadres</Label>
                <Input data-testid="contact-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-oc-btn" />
              </div>
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>Categorie</Label>
                <Select value={category} onValueChange={setCategory}>
                  <SelectTrigger data-testid="contact-category" className="h-12 rounded-oc-btn">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="algemeen">Algemeen</SelectItem>
                    <SelectItem value="support">Hulp bij analyse</SelectItem>
                    <SelectItem value="facturatie">Facturatie</SelectItem>
                    <SelectItem value="privacy">Privacy / GDPR</SelectItem>
                    <SelectItem value="pers">Pers / partnership</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div className="space-y-2">
                <Label>Onderwerp</Label>
                <Input data-testid="contact-subject" value={subject} onChange={(e) => setSubject(e.target.value)} className="h-12 rounded-oc-btn" />
              </div>
            </div>
            <div className="space-y-2">
              <Label>Bericht</Label>
              <Textarea data-testid="contact-message" value={message} onChange={(e) => setMessage(e.target.value)} className="min-h-[160px] rounded-oc-btn" />
            </div>
            <Button data-testid="contact-submit" disabled={loading} onClick={send} className="bg-oc-primary hover:bg-oc-secondary text-white rounded-oc-btn h-12 px-7 font-semibold w-full sm:w-auto">
              {loading ? "Verzenden..." : "Verstuur bericht"}
            </Button>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
